export const PIXEL_ID = '1225428543097695'
export const CHECKOUT_URL =
  'https://pay.hotmart.com/L105000144W?checkoutMode=10'
export const COUNTDOWN_SECONDS = 643 // 10 min 43 sec

export const IMAGES = {
  tomo1:
    'https://cdn.magicpatterns.com/uploads/2sCbJWLWJFhdazrpHrk8XR/tomo_1.png',
  tomo2:
    'https://cdn.magicpatterns.com/uploads/oj9AEjU2g6DQwRsczu86TD/tomo_2.png',
  tomo3:
    'https://cdn.magicpatterns.com/uploads/vjCeN8uFBzeZaC1qqLDve3/tomo_3.png',
  tomo4:
    'https://cdn.magicpatterns.com/uploads/mZi2UAYt52mk9q1RaC8ZHm/tomo_4.png',
  tomo5:
    'https://cdn.magicpatterns.com/uploads/t6LVejYGM3SDSSZHbnds8n/tomo_5.png',
}

export const PRICES = {
  original: '79,99 \u20AC',
  sale: '14,99 \u20AC',
  totalValue: '130,95 \u20AC',
  savings: '81%',
}

export const PRODUCT_ITEMS = [
  {
    title: 'Fondamenti del Tango e Struttura della Lezione',
    description: `Una guida pratica per costruire lezioni di tango chiare, professionali ed efficaci fin dalla prima classe.`,
  },
  {
    title: 'Tecnica e Progressione Didattica',
    description: `Un metodo concreto per insegnare tecnica, postura, connessione e progressione in modo ordinato e comprensibile.`,
  },
  {
    title: 'Sequenze e Dinamiche di Classe',
    description: `Idee pratiche e strutture di lezione per rendere ogni classe più fluida, coinvolgente e memorabile.`,
  },
  {
    title: `Musicalità e Interpretazione nel Tango`,
    description: `Strategie semplici per aiutare gli allievi a sentire la musica, interpretarla meglio e ballare con maggiore consapevolezza.`,
  },
  {
    title: 'Gestione della Classe e degli Studenti',
    description: `La risorsa completa per gestire gruppi, livelli diversi, difficoltà comuni e migliorare l\u2019esperienza generale dei tuoi allievi.`,
  },
]

export const BONUS_ITEMS = [
  {
    title: 'Planner Professionale per Lezioni di Tango',
    description: `Template pronti da usare per organizzare le tue lezioni in modo semplice, veloce e professionale.`,
    value: '12,99 \u20AC',
  },
  {
    title: 'Checklist della Lezione Perfetta di Tango',
    description: `Una checklist pratica per non dimenticare nulla e rendere ogni lezione più efficace e ben strutturata.`,
    value: '9,99 \u20AC',
  },
  {
    title: 'Mini Sistema di Fidelizzazione degli Allievi',
    description: `Idee utili per migliorare l\u2019esperienza degli studenti e aumentare la continuità delle lezioni.`,
    value: '14,99 \u20AC',
  },
  {
    title: `Piano Rapido per Coinvolgere di Più gli Studenti`,
    description: `Un bonus strategico per aiutarti a mantenere i tuoi allievi più motivati, presenti e soddisfatti.`,
    value: '12,99 \u20AC',
  },
]

export const TESTIMONIALS = [
  {
    name: 'Giulia',
    age: 34,
    city: 'Milano',
    review: `Finalmente ho una struttura chiara per le mie lezioni di tango. I miei studenti sono più coinvolti e anch\u2019io mi sento molto più sicura quando insegno.`,
  },
  {
    name: 'Marco',
    age: 41,
    city: 'Roma',
    review: `Questo pack mi ha aiutato a rendere le lezioni molto più dinamiche. Gli studenti partecipano di più e noto progressi più rapidi.`,
  },
  {
    name: 'Elena',
    age: 29,
    city: 'Torino',
    review: `Prima improvvisavo spesso. Adesso ho un metodo semplice da seguire e le lezioni risultano molto più professionali.`,
  },
  {
    name: 'Davide',
    age: 46,
    city: 'Napoli',
    review: `Ho trovato idee pratiche, immediate e davvero utili. Consigliatissimo a chi insegna tango e vuole fare un salto di qualità.`,
  },
  {
    name: 'Francesca',
    age: 38,
    city: 'Bologna',
    review: `Una risorsa completa e ben fatta. Mi ha aiutata tantissimo a motivare meglio i miei studenti e a organizzare tutto con più chiarezza.`,
  },
]

export const FAQS = [
  {
    question: `Questo prodotto è adatto a qualsiasi insegnante di tango?`,
    answer: `Sì, il Metodo Completo è pensato per insegnanti di tango che lavorano con principianti, intermedi o gruppi misti e che vogliono dare più struttura alle proprie lezioni.`,
  },
  {
    question: `Riceverò accesso immediato dopo l\u2019acquisto?`,
    answer: `Sì, subito dopo il pagamento riceverai accesso immediato a tutto il materiale digitale.`,
  },
  {
    question: 'Devo avere esperienza pedagogica per applicarlo?',
    answer: `No, il materiale è stato pensato per essere semplice, pratico e utilizzabile anche da chi non ha una formazione pedagogica avanzata.`,
  },
  {
    question: `Il pagamento è unico?`,
    answer: `Sì, paghi una sola volta. Non ci sono abbonamenti né costi nascosti.`,
  },
  {
    question: `È prevista una garanzia?`,
    answer: `Sì, hai una garanzia di 45 giorni per acquistare in totale tranquillità.`,
  },
]

export const BUYER_NAMES = [
  { name: 'Luca', city: 'Firenze' },
  { name: 'Martina', city: 'Verona' },
  { name: 'Alessio', city: 'Palermo' },
  { name: 'Serena', city: 'Bari' },
  { name: 'Andrea', city: 'Genova' },
  { name: 'Chiara', city: 'Padova' },
  { name: 'Matteo', city: 'Catania' },
  { name: 'Silvia', city: 'Parma' },
  { name: 'Federico', city: 'Perugia' },
  { name: 'Valentina', city: 'Trieste' },
  { name: 'Paolo', city: 'Modena' },
  { name: 'Laura', city: 'Venezia' },
]
